<template>
  <div
    class="z-top absolute-full"
    data-test-id="pinch-zoom-animation"
    style="pointer-events: none;"
  >
    <div class="pinch-zoom-animation">
      <div
        class="pinch-zoom-text absolute-center text-responsive text-bold text-body1"
      >
        {{ $t('seatChart.pinchZoom') }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PinchZoomAnimation'
}

</script>
<style lang="scss" scoped>
.pinch-zoom-text {
  display: block;
  width: fit-content;
  height: fit-content;
}
.pinch-zoom-animation {
  width: 80%;
  height: 80%;
  max-width: 600px;
  max-height: 600px;
  position: absolute;
  pointer-events: none;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  animation: fade-in-out 2s ease-in-out forwards infinite;
}
.body--light .pinch-zoom-animation:before {
  content: '';
  position: absolute;
  width: 30px;
  height: 30px;
  border: 2px solid  rgba(0, 0, 0, 0.2);
  border-radius: 30px;
  z-index: 1;
  background: rgba(0, 0, 0, 0.05);
  will-change: transform;
  top: 40%;
  left: 55%;
  transform: translate(0%,0%);
  animation: gesture-a 2s ease-in-out forwards infinite;
}
.body--light .pinch-zoom-animation:after {
  content: '';
  position: absolute;
  width: 30px;
  height: 30px;
  border: 2px solid rgba(0, 0, 0, 0.2);
  border-radius: 30px;
  z-index: 1;
  background: rgba(0, 0, 0, 0.05);
  will-change: transform;
  top: 60%;
  left: 35%;
  transform: translate(100%,-100%);
  animation: gesture-b 2s ease-in-out forwards infinite;
}
@keyframes fade-in-out {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
}
@keyframes gesture-a {
    0% {
      transform: translate(0%,0%)
    }
    10% {
      opacity: 1;
    }
    25% {
      background: rgba(0, 0, 0, 0.05);
    }
    50% {
      transform: translate(100%,-100%);
      background: rgba(0, 0, 0, 0.2);
    }
    75% {

      background: rgba(0, 0, 0, 0.2);
      opacity: 1;
    }
    100% {
      transform: translate(0%,0%);
      background: rgba(0, 0, 0, 0.2);
      opacity: 0;
    }
}
@keyframes gesture-b {
    0% {
      transform: translate(100%,-100%)
    }
    10% {
      opacity: 1;
    }
    25% {

      background: rgba(0, 0, 0, 0.05);
    }
    50% {
      transform: translate(0%,0%);
      background: rgba(0, 0, 0, 0.2);
    }
    75% {

      background: rgba(0, 0, 0, 0.2);
      opacity: 1;
    }
    100% {
      transform: translate(100%,-100%);
      background: rgba(0, 0, 0, 0.2);
      opacity: 0;
    }
}
.body--dark .pinch-zoom-animation:before {
  content: '';
  position: absolute;
  width: 30px;
  height: 30px;
  border: 2px solid #fff;
  border-radius: 30px;
  z-index: 1;
  background: hsla(0,0%,100%,.3);
  will-change: transform;
  top: 40%;
  left: 55%;
  transform: translate(0%,0%);
  animation: gesture-c 2s ease-in-out forwards infinite;
}
.body--dark .pinch-zoom-animation:after {
  content: '';
  position: absolute;
  width: 30px;
  height: 30px;
  border: 2px solid  #fff;
  border-radius: 30px;
  z-index: 1;
  background: hsla(0,0%,100%,.3);
  will-change: transform;
  top: 60%;
  left: 35%;
  transform: translate(100%,-100%);
  animation: gesture-d 2s ease-in-out forwards infinite;
}

@keyframes gesture-c {
    0% {
        transform: translate(0%,0%)
    }
    10% {
      opacity: 1;
    }
    25% {
      background: hsla(0,0%,100%,.3);
    }
    50% {
      transform: translate(100%,-100%);
      background: hsla(0,0%,100%,.8);
    }
    75% {

      background: hsla(0,0%,100%,.8);
      opacity: 1;
    }
    100% {
      transform: translate(0%,0%);
      background: hsla(0,0%,100%,.8);
      opacity: 0;
    }
}
@keyframes gesture-d {
    0% {
        transform: translate(100%,-100%)
    }
    10% {
      opacity: 1;
    }
    25% {

      background: hsla(0,0%,100%,.3);
    }
    50% {
      transform: translate(0%,0%);
      background: hsla(0,0%,100%,.8);
    }
    75% {

      background: hsla(0,0%,100%,.8);
      opacity: 1;
    }
    100% {
      transform: translate(100%,-100%);
      background: hsla(0,0%,100%,.8);
      opacity: 0;
    }
}
</style>
